<template>
    <div>
        <div class="container d-flex align-items-center vh-100 justify-content-center">
            <div>
                <div class="text-center">
                    <div class="logo-wrapper">
                        <img :src="logo" :style="{ height: '80px', width: 'auto', maxWidth: '100%', objectFit: 'contain' }"/>
                    </div>
                </div>
                <div class="text-center my-5">
                    <span>
                        <i class="ri-emotion-sad-line ri-8x m-0 p-0"></i>
                    </span>
                    <h1 class="mb-1">{{ $t('page_not_found') }}</h1>
                    <h4 class="mb-5">{{ $t('sorry_we_could_not_find_the_page_you_were_looking_for') }}</h4>
                    <div class="d-flex justify-content-center">
                        <b-button size="sm" variant="link" @click="goBack" class="small mt-5">
                            <i class="ri-arrow-left-line mr-2 h6 mb-0 font-weight-normal top-plus-0"></i>
                            {{ $t('turn_back').toUpper() }}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ConstantService from "@/services/ConstantService";

    export default {
        name: 'Error404',
        data() {
            return {
                logo: null,
                // defaultLogo: require('@/assets/img/bau-logo-for-light.svg')
            }
        },
        created() {
            this.getLogo();
        },
        methods: {
            getLogo() {
                ConstantService.downloadPublicFile('document_logo')
                    .then(res => {
                        if (res && res.data && res.data.byteLength > 0) {
                            const contentType = (res.headers && res.headers['content-type']) || 'image/png';
                            const blob = new Blob([res.data], { type: contentType });
                            this.logo = URL.createObjectURL(blob);
                        }
                    })
                    .catch(err => {
                        console.error("Error fetching document_logo:", err);
                    });
            },
            goBack() {
                this.$router.push('/')
            }
        }
    }
</script>

